/* eslint-disable prettier/prettier */
import { useUserProfile } from '../hooks/useUserProfile';
import AdminDashboard from '../pages/admin/AdminDashboard';
import LearnerDashboard from '../pages/learner/NavLearnerDashboard';
import GuestDashboardPage from '../pages/GuestDashboardPage';
import NavCoachMentorDashboard from '../pages/coach-mentor/NavCoachMentorDashboard';
import CoachMentorDashboard from '../pages/coach-mentor/CoachMentorDashboard';
import NavAdminDashboard from '../pages/admin/NavAdminDashboard';

const RoleBasedRedirect = () => {
	const { profile, loading, error } = useUserProfile();

	if (loading) return null;
	if (error || !profile) return null;

	const roleName = profile.rolename?.toLowerCase();

	switch (roleName) {
		case 'superadmin':
			return <NavAdminDashboard />;

		case 'master coach':
		case 'coach mentor':
		case 'coach':
			return <CoachMentorDashboard />;

		case 'learner':
		case 'coachee':
			return <LearnerDashboard />;

		default:
			return <GuestDashboardPage />;
	}
};

export default RoleBasedRedirect;
